import { ajaxLoadCart } from "./loadCart";

export default function removeCart() {
  $('.js-remove-cart').on('click', function () {
    const id = $(this).data('cart-id');

    $.ajax({
      method: 'POST',
      dataType: 'json',
      url: '/wp-admin/admin-ajax.php',
      data: {
        action: 'remove_from_cart',
        id: id
      },
      success: function (response) {
        alert(response.message);
        $('.cart-count').text(response.count);
        ajaxLoadCart();
        $('.cart-content').removeClass('show');
      },
      error: function (jqXHR, textStatus, errorThrown) {
        console.log('The following error occured: ' + textStatus, errorThrown);
      }
    });
    return false;
  });
};
